const features = [
  {
    title: "Emissão NFe",
    description: "Venda interna simples na Fase 1; catálogo completo emitente nas fases seguintes.",
  },
  {
    title: "Cancelamento e CC-e",
    description: "Eventos fiscais com trilha de auditoria e XML armazenado com segurança.",
  },
  {
    title: "Consulta por chave",
    description: "Download de XML autorizado e status SEFAZ sem depender do ERP.",
  },
  {
    title: "DFe destinatário",
    description: "Manifestação e distribuição — visão completa do ciclo fiscal.",
  },
  {
    title: "API B2B",
    description: "Chaves por empresa, escopos granulares e rotas anti-IDOR.",
  },
  {
    title: "Webhooks",
    description: "Notifique seu ERP quando a nota autorizar, cancelar ou falhar.",
  },
]

export const FeaturesSection = () => {
  return (
    <section id="recursos" className="bg-white py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="max-w-2xl">
          <h2 className="text-3xl font-bold text-slate-900">Funcionalidades</h2>
          <p className="mt-3 text-slate-600">
            Tudo que ERPs e integradores esperam de um hub fiscal moderno — alinhado ao roadmap do produto.
          </p>
        </div>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((item) => (
            <article
              key={item.title}
              className="rounded-2xl border border-slate-200 bg-slate-50 p-6 shadow-sm"
            >
              <h3 className="text-lg font-semibold text-slate-900">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
